

































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { VeeValidateObserverRef } from '@/models/Common/Validation'
import Setting from '@/store/modules/Setting'
import Auth from '@/store/modules/Auth'
import AuthService from '@/services/AuthService'
import store from '@/store'
import UserService from '@/services/UserService'
import UserInfo from '@/store/modules/UserInfo'
import moment from 'moment'
import { loadAuthenticatedSessionData } from '@/helpers/loadAuthenticatedSession'
import { ERR_API_KEY } from '@/constants'
import router from "@/router";
const SettingModule = getModule(Setting, store)
const AuthModule = getModule(Auth, store)
const UserModule = getModule(UserInfo, store)

@Component({
  metaInfo: {
    meta: [
      {
        name: 'robots',
        content: 'noindex,nofollow,noarchive'
      }
    ]
  }
})
export default class Login extends Vue {
  $refs!: {
    observer: VeeValidateObserverRef
  }
  line_url: any = ''
  private random_state: any = ''
  private redirect_url: any = globalThis.location.origin + '/line-login/'
  resetPasswordExpired: boolean = false
  current_date: any = ''
  isLoginWithEmail: boolean = true
  employee_email: string = ''
  company_id: string = ''
  employee_number: string = ''
  employee_password: string = ''
  isLoadingLogin: boolean = false
  notifications: any[] = []
  login_status_msg: string = ''
  // NWS-1942: パスワードの表示／非表示（初期は非表示）
  showPassword: boolean = false

  created() {
    if (localStorage.getItem('device_token')) {
      let params = {
        user_id: localStorage.getItem('user_logged_id'),
        token: localStorage.getItem('device_token')
      }
      AuthService.resetTotalNotificationBeforeLogin(params).then(
        async response => {
          if (response.status === 200) {
            await AuthService.deleteDeviceToken(params).then(response => {
              if (response.status === 200) {
                sessionStorage.clear()
                localStorage.clear()
              }
            })
          }
        }
      )
    } else {
      sessionStorage.clear()
      localStorage.clear()
    }
    this.random_state = Math.random()
      .toString(36)
      .substr(5, 9)
    this.line_url = `https://access.line.me/oauth2/v2.1/authorize?client_id=${process.env.VUE_APP_LINE_CLIENT_ID}&scope=openid+profile+email&state=${this.random_state}&response_type=code&redirect_uri=${this.redirect_url}`
    this.current_date = moment.now()
    this.getNotificationBeforeLogin()
    if (this.$route.query.reset_password_expired === 'true') {
      this.resetPasswordExpired = true
    } else return
  }

  loginWithEmail() {
    if (!this.isLoginWithEmail) {
      this.isLoginWithEmail = true
      this.company_id = ''
      this.employee_email = ''
      this.employee_password = ''
      this.showPassword = false
      this.login_status_msg = ''
      this.$refs.observer.reset()
    }
  }

  loginWithId() {
    if (this.isLoginWithEmail) {
      this.isLoginWithEmail = false
      this.company_id = ''
      this.employee_number = ''
      this.employee_password = ''
      this.showPassword = false
      this.login_status_msg = ''
      this.$refs.observer.reset()
    }
  }

  login() {
    this.$refs.observer.validate().then(async isValidate => {
      if (!isValidate) return
      // 送信時は非表示に戻す（画面に残さない・ブラウザのパスワード保存が欄を見失わないように）
      this.showPassword = false
      this.isLoadingLogin = true
      const loginWithEmail = {
        company_id: this.company_id,
        email: this.employee_email,
        password: this.employee_password
      }
      const loginWithId = {
        company_id: this.company_id,
        employee_number: this.employee_number,
        password: this.employee_password
      }
      try {
        const response = await AuthService.login(
          this.isLoginWithEmail ? loginWithEmail : loginWithId
        )
        if (response.status === 200) {
          const token = response.data.items.token
          const user_id = response.data.items.user_id
          const shouldUpdatePassword =
            response.data.items.change_password_flag === 0
          AuthModule.SET_NEW_TOKEN(token)
          UserModule.HANDLE_USER_ID(user_id)
          if (token) {
            await this.checkUserBelongToGroup(shouldUpdatePassword)
          }
          if (response.data.items.needs_acceptance) {
            localStorage.setItem('needs_acceptance', 'true')
            // Defer acceptance until after mandatory password update
            if (!shouldUpdatePassword) {
              await router.push({ name: 'acceptance' })
            }
          } else {
            localStorage.removeItem('needs_acceptance')
          }
        }
      } catch (error: any) {
        const errorMess = error.response?.data?.message
        if (
          [
            ERR_API_KEY.LOGIN_AUTHORIZED_EMAIL,
            ERR_API_KEY.LOGIN_AUTHORIZED_EMPLOYEE_ID,
            ERR_API_KEY.USER_HAS_BEEN_LOCKED,
            ERR_API_KEY.INVALID_USER_STATUS
          ].includes(errorMess)
        ) {
          this.login_status_msg = errorMess
        } else {
          this.login_status_msg = 'failed_login_msg'
        }
      } finally {
        this.isLoadingLogin = false
      }
    })
  }

  loginWithLine() {
    if (this.$route.query.redirect) {
      AuthModule.SET_REDIRECT_LOGIN_WITH_LINE(
        this.$route.query.redirect as string
      )
    }
  }

  checkUserBelongToGroup(shouldUpdatePassword: boolean): Promise<void> {
    return AuthService.checkUserBelongToGroup()
      .then(response => {
        if (response.status === 200) {
          if (response.data.is_user_belong_to_group === true) {
            AuthModule.SET_SHOULD_UPDATE_PASSWORD(shouldUpdatePassword)
            this.resetStoreToDefault()
            loadAuthenticatedSessionData()
            if (shouldUpdatePassword) {
              this.$bvModal.show('modal-update-password')
            } else {
              this.$router.push({
                  path: this.$route.query.redirect
                    ? String(this.$route.query.redirect)
                    : '/'
                })
            }
          } else {
            this.$router.push({ name: 'employee-without-group' })
          }
          sessionStorage.setItem(
            'is_user_belong_to_group',
            response.data.is_user_belong_to_group
          )
        }
      })
      .catch(error => {
        sessionStorage.setItem('is_user_belong_to_group', 'false')
        if (error.response?.data?.is_request_join_group) {
          this.$bvModal.show('modal-info-login')
        } else {
          this.$router.push({ name: 'employee-without-group' })
          console.log(error)
        }
      })
  }

  resetStoreToDefault() {
    UserModule.RESET_DEFAULT()
    SettingModule.RESET_DEFAULT()
  }

  getNotificationBeforeLogin() {
    UserService.getNotificationBeforeLogin()
      .then(response => {
        if (response.status === 200) {
          this.notifications = response.data.map((item: any) => {
            return {
              content: item.content,
              public_date: moment(item.public_date).format('MM/DD'),
              timestamp: moment(item.public_date).valueOf()
            }
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  resetMsg() {
    this.resetPasswordExpired = false
    this.login_status_msg = ''
  }

  togglePassword() {
    this.showPassword = !this.showPassword
  }
}
